import styled from 'styled-components';

export const MembershipSelectorMenuListContainer = styled.div`
  display: flex;
  align-items: center;
`;
